import { ReactGA } from "~/utils/reactGa";

const { event } = ReactGA;

interface EventParams {
  action: string;
  label?: string;
  value?: number;
}

const hasStatisticsConsent = () => {
  const cookieYesConsent = window.getCkyConsent ? window.getCkyConsent() : null;
  const consentViaCookieYes =
    cookieYesConsent && cookieYesConsent.categories.analytics;
  const noCmp = !window.getCkyConsent;

  return noCmp || consentViaCookieYes;
};

export const gaEventFactory =
  (category: string): any =>
  ({ action, label, value }: EventParams): void => {
    if (!hasStatisticsConsent()) {
      return;
    }

    const categoryParams = {
      event_category: category,
      custom_location_category: category,
      category,
    };

    const labelParams = label
      ? {
          event_label: label,
          custom_location_label: label,
          label,
        }
      : {};

    return event(action, {
      ...categoryParams,
      ...labelParams,
      value,
    });
  };
